import { useQuery } from '@tanstack/react-query';
import type { CustomSkill } from '../types';

export default function useCustomSkill(companyId: string, skillId: string | null) {
  return useQuery<CustomSkill>({
    queryKey: ['admin', 'companies', companyId, 'custom-skills', skillId],
    enabled: skillId !== null,
  });
}
